/**
 * State used in rendering DrawerHeaderTitle
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
